// extracted by mini-css-extract-plugin
export default {"productGrid":"S1-z","centerLink":"T1-z","productSection":"U1-z","item":"V1-z","ctaButton":"W1-z"};